import React from 'react';
import { Chart } from 'primereact/chart';
import { useSelector, useDispatch } from 'react-redux';
import { loadSessionsDailySummaryAsync, selectSessionsDailySummary } from '../dashboardSlice';
import { ChartCard } from './ChartCard';

const HISTORY_DAYS = 30;

export const SessionsActivityChart = () => {
    const dispatch = useDispatch();
    const { data, status, error } = useSelector(selectSessionsDailySummary);

    const prepareData = () => {
        if (!Array.isArray(data) || !data.length) {
            return {
                labels: [],
                datasets: [{
                    label: 'Usuários com sessão',
                    data: [],
                    borderColor: '#26A69A',
                    backgroundColor: 'rgba(38, 166, 154, 0.1)',
                    tension: 0.4,
                    fill: true
                }]
            };
        }

        const sortedData = [...data].sort((a, b) => new Date(a.date) - new Date(b.date));

        return {
            labels: sortedData.map(item => item.date),
            datasets: [{
                label: 'Usuários com sessão',
                data: sortedData.map(item => item.userCount),
                borderColor: '#26A69A',
                backgroundColor: 'rgba(38, 166, 154, 0.1)',
                tension: 0.4,
                fill: true
            }]
        };
    };

    return (
        <ChartCard
            title="Usuários com sessão por dia"
            loading={status === 'loading'}
            error={error}
            onReload={() => dispatch(loadSessionsDailySummaryAsync(HISTORY_DAYS))}
        >
            <Chart type="line" data={prepareData()} />
        </ChartCard>
    );
};
